import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { EvacZoneStatus, RegionEvacZoneStyle } from 'shared/types';
import { EVAC_ZONE_LABEL_TRANS_KEYS } from '../../../../constants';
import { getEvacZoneStatusChipStyles } from '../../utils/getEvacZoneStatusChipStyles';

type StatusChipProps = {
  evacZoneStatus?: EvacZoneStatus;
  evacZoneStyle: RegionEvacZoneStyle;
};

export const StatusChip = ({
  evacZoneStatus: status,
  evacZoneStyle: style,
}: StatusChipProps): JSX.Element => {
  const theme = useTheme();
  const { t } = useTranslation();
  const label = status
    ? t(`${EVAC_ZONE_LABEL_TRANS_KEYS[style][status]}Short`)
    : t('geoEventEvacuations.evacZones.normal');

  const { backgroundColor, color } = getEvacZoneStatusChipStyles(
    theme,
    style,
    status,
  );

  return (
    <Chip
      label={label}
      size="small"
      component="span"
      variant="watchduty"
      sx={{
        height: 18,
        backgroundColor,
        color,
        alignSelf: 'center',
      }}
    />
  );
};
